// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container {
  position: absolute;
  display: inline-block;
  pointer-events: all;
  z-index: 3;
  height: 100%;
  width: 3px;
  background-color: black;
  cursor: ew-resize;
}

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button {
    height: 100%;
    width: 100%;
    position: relative;
  }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__upperTriangle {
      position: absolute;
      top: 0;
    }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__upperTriangle[position='min'] {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 7px 0 0;
        border-color: black transparent transparent transparent;
      }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__upperTriangle[position='max'] {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 7px 7px 0;
        border-color: transparent black transparent transparent;
        left: -4px;
      }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__downerTriangle {
      position: absolute;
      bottom: 0;
    }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__downerTriangle[position='min'] {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 7px 0 0 7px;
        border-color: transparent transparent transparent black;
      }

  .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button .app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__downerTriangle[position='max'] {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 0 7px 7px;
        border-color: transparent transparent black transparent;
        left: -4px;
      }

.app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__disabled {
  cursor: initial;
}
`, "",{"version":3,"sources":["webpack://./app/components/Table/Cells/ColumnTimeline/TimelineMaxResizer.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AAiDnB;;EA/CE;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EA2CpB;;EAzCE;MACE,kBAAkB;MAClB,MAAM;IAiBR;;EAfE;QACE,QAAQ;QACR,SAAS;QACT,mBAAmB;QACnB,yBAAyB;QACzB,uDAAuD;MACzD;;EACA;QACE,QAAQ;QACR,SAAS;QACT,mBAAmB;QACnB,yBAAyB;QACzB,uDAAuD;QACvD,UAAU;MACZ;;EAGF;MACE,kBAAkB;MAClB,SAAS;IAiBX;;EAfE;QACE,QAAQ;QACR,SAAS;QACT,mBAAmB;QACnB,yBAAyB;QACzB,uDAAuD;MACzD;;EACA;QACE,QAAQ;QACR,SAAS;QACT,mBAAmB;QACnB,yBAAyB;QACzB,uDAAuD;QACvD,UAAU;MACZ;;AAKN;EACE,eAAe;AACjB","sourcesContent":[".container {\n  position: absolute;\n  display: inline-block;\n  pointer-events: all;\n  z-index: 3;\n  height: 100%;\n  width: 3px;\n  background-color: black;\n  cursor: ew-resize;\n\n  .button {\n    height: 100%;\n    width: 100%;\n    position: relative;\n\n    .upperTriangle {\n      position: absolute;\n      top: 0;\n\n      &[position='min'] {\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 7px 7px 0 0;\n        border-color: black transparent transparent transparent;\n      }\n      &[position='max'] {\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 0 7px 7px 0;\n        border-color: transparent black transparent transparent;\n        left: -4px;\n      }\n    }\n\n    .downerTriangle {\n      position: absolute;\n      bottom: 0;\n\n      &[position='min'] {\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 7px 0 0 7px;\n        border-color: transparent transparent transparent black;\n      }\n      &[position='max'] {\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 0 0 7px 7px;\n        border-color: transparent transparent black transparent;\n        left: -4px;\n      }\n    }\n  }\n}\n\n.disabled {\n  cursor: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__container`,
	"button": `app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__button`,
	"upperTriangle": `app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__upperTriangle`,
	"downerTriangle": `app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__downerTriangle`,
	"disabled": `app-components-Table-Cells-ColumnTimeline-___TimelineMaxResizer-module__disabled`
};
export default ___CSS_LOADER_EXPORT___;
